/**
 * @owner @Appboy/core-objects
 */

// generated from 74 samples

import { z } from "zod";

export const catalogPriceDropTriggerGetSchema = z.object({
  event_type: z.literal("TrackedUserBehavior::CatalogPriceDrop"),
  // null: 8 (10.81%)
  catalog_name: z.string().nullable(),
  market_handle: z.string().nullable().optional(),
  subscription_type: z.null(),
});
